//
// BIRDData.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./DataFormat";
import "./BIRDDataLayout";

var BIRDData = createModule("BIRD::BIRDData", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        isIndexed: 2,
        contentKey: 7,
        size: 4,
        availableRowCount: 4,
        grandTotal: 2,
        dataLayout: 4,
        format: 4,
        rowCount: 4,
        content: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default BIRDData;
